"use strict";

export function initInScope ($scope) {
    $scope.find('.js-copy-value').on('change input', function (evt) {
        let $this = $(this),
            targetInput = $($this.data('copy-target'));

        targetInput.val($this.val()).trigger('paste');
    });
}